const map = {
	"./Aliluja/Sunday/Glas1/csj.mdx": 47696,
	"./Aliluja/Sunday/Glas2/csj.mdx": 10679,
	"./Aliluja/Sunday/Glas3/csj.mdx": 64354,
	"./Aliluja/Sunday/Glas4/csj.mdx": 25073,
	"./Aliluja/Sunday/Glas5/csj.mdx": 32012,
	"./Aliluja/Sunday/Glas6/csj.mdx": 60787,
	"./Aliluja/Sunday/Glas7/csj.mdx": 65454,
	"./Aliluja/Sunday/Glas8/csj.mdx": 30557,
	"./Aliluja/WeekDays/1/csj.mdx": 49550,
	"./Aliluja/WeekDays/2/csj.mdx": 6641,
	"./Aliluja/WeekDays/3/csj.mdx": 6572,
	"./Aliluja/WeekDays/4/csj.mdx": 94647,
	"./Aliluja/WeekDays/5/csj.mdx": 22146,
	"./Aliluja/WeekDays/6/csj.mdx": 61781,
	"./Antifon1/csj.mdx": 37608,
	"./Antifon1Ascension/csj.mdx": 94481,
	"./Antifon1Christmas/csj.mdx": 29856,
	"./Antifon1Easter/csj.mdx": 80782,
	"./Antifon1Epiphany/csj.mdx": 93466,
	"./Antifon1Pentecost/csj.mdx": 28923,
	"./Antifon1Transfiguration/csj.mdx": 85216,
	"./Antifon1VhodGospoden/csj.mdx": 17904,
	"./Antifon1Vozdvijenie/csj.mdx": 82045,
	"./Antifon2/csj.mdx": 8207,
	"./Antifon2Ascension/csj.mdx": 96876,
	"./Antifon2Christmas/csj.mdx": 49961,
	"./Antifon2Easter/csj.mdx": 13749,
	"./Antifon2Epiphany/csj.mdx": 28273,
	"./Antifon2Pentecost/csj.mdx": 26702,
	"./Antifon2Transfiguration/csj.mdx": 38353,
	"./Antifon2VhodGospoden/csj.mdx": 83443,
	"./Antifon2Vozdvijenie/csj.mdx": 46736,
	"./Antifon3/csj.mdx": 55834,
	"./Antifon3Ascension/csj.mdx": 39511,
	"./Antifon3Christmas/csj.mdx": 99990,
	"./Antifon3Easter/csj.mdx": 5064,
	"./Antifon3Epiphany/csj.mdx": 67008,
	"./Antifon3Pentecost/csj.mdx": 32921,
	"./Antifon3Transfiguration/csj.mdx": 26758,
	"./Antifon3VhodGospoden/csj.mdx": 29694,
	"./Antifon3Vozdvijenie/csj.mdx": 21019,
	"./AntifonVsednev1/csj.mdx": 11201,
	"./AntifonVsednev2/csj.mdx": 25630,
	"./AntifonVsednev3/csj.mdx": 81859,
	"./BeforeGospel/csj.mdx": 79735,
	"./BlessBeforeGosp/csj.mdx": 87201,
	"./EktenyaOglashaemie/csj.mdx": 94484,
	"./Izydite/csj.mdx": 31548,
	"./MalajaEktenia/csj.mdx": 53881,
	"./MalijVhod/csj.mdx": 81534,
	"./MirTebeApostol/csj.mdx": 13562,
	"./MirTebeBlag/csj.mdx": 73594,
	"./Molitva1/csj.mdx": 23283,
	"./Molitva2/csj.mdx": 17804,
	"./Molitva3/csj.mdx": 51377,
	"./Oglashaemie/csj.mdx": 84361,
	"./OglashaemieVasiliy/csj.mdx": 95340,
	"./OtpustOglashaemie/csj.mdx": 37098,
	"./PredMalijVhod/csj.mdx": 38397,
	"./PremBeforeGospel/csj.mdx": 48571,
	"./Priugotovl/csj.mdx": 38541,
	"./Prokimens/Sunday/Glas1/csj.mdx": 7244,
	"./Prokimens/Sunday/Glas2/csj.mdx": 52371,
	"./Prokimens/Sunday/Glas3/csj.mdx": 57038,
	"./Prokimens/Sunday/Glas4/csj.mdx": 93621,
	"./Prokimens/Sunday/Glas5/csj.mdx": 39280,
	"./Prokimens/Sunday/Glas6/csj.mdx": 85911,
	"./Prokimens/Sunday/Glas7/csj.mdx": 55938,
	"./Prokimens/Sunday/Glas8/csj.mdx": 80889,
	"./Prokimens/WeekDays/1/csj.mdx": 13170,
	"./Prokimens/WeekDays/2/csj.mdx": 25957,
	"./Prokimens/WeekDays/3/csj.mdx": 33632,
	"./Prokimens/WeekDays/4/csj.mdx": 51171,
	"./Prokimens/WeekDays/5/csj.mdx": 53406,
	"./Prokimens/WeekDays/6/csj.mdx": 18017,
	"./Reading/csj.mdx": 40094,
	"./SugubajaEktenia/csj.mdx": 97625,
	"./Trisvatoe/GospoduPomolimsa/csj.mdx": 48070,
	"./Trisvatoe/MolitvaPered/csj.mdx": 83530,
	"./Trisvatoe/MolitvaPeredOk1/csj.mdx": 72925,
	"./Trisvatoe/MolitvaPeredOk2/csj.mdx": 43434,
	"./Trisvatoe/MolitvaPeredOk3/csj.mdx": 94079,
	"./Trisvatoe/PeredTrisvatoe/csj.mdx": 5285,
	"./Trisvatoe/Trisvatoe/csj.mdx": 69699,
	"./Userdnaya/csj.mdx": 36088,
	"./Usopshiye/csj.mdx": 17941,
	"./VelikajaEktenia/csj.mdx": 45618,
	"./VhodnoiStih/Budni/csj.mdx": 85048,
	"./VhodnoiStih/Sunday/csj.mdx": 70438,
	"./Vozglas/csj.mdx": 60494,
	"./Zaupokoynaya/csj.mdx": 30797
};



function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then((id) => (__webpack_require__(id)));
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | mdx-liturgy-katekhumen-csj */ 23162).then(() => {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 89327;
module.exports = webpackAsyncContext;